import { useEffect } from 'react'

import { PageContent, PageHeader, PageTitle } from '~/elements/PageHeader'
import { WorkspacesLayout } from '~/features/workspaces/layout/WorkspacesLayout'
import { useCurrentWorkspacePlan } from '~/features/billing/hooks/useBillingHooks'

import { AddonsCard } from '~/components/billing/AddonsCard.tsx'
import { SelectPeriod } from '~/components/billing/SelectPeriod.tsx'
import { Plans } from '~/components/billing/Plans.tsx'
import { PricingComparison } from '~/components/billing/PricingComparison.tsx'
import { SpendCapCard } from '~/components/billing/SpendCapCard.tsx'
import { SubscriptionSummary } from '~/components/billing/SubscriptionSummary.tsx'
import { UsageMeters } from '~/components/billing/UsageMeters.tsx'

export function WorkspaceBillingPage() {
  const params = new URLSearchParams(window.location.search)
  const intendedPlan = params.get('plan') ?? undefined
  const section = params.get('section')
  const { state, loading } = useCurrentWorkspacePlan()

  useEffect(() => {
    if (section && state) {
      document.getElementById(`billing-${section}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [section, state])

  return (
    <WorkspacesLayout>
      <PageHeader contained>
        <PageTitle>Billing</PageTitle>
      </PageHeader>
      <PageContent className="gap-5" contained>
        <SubscriptionSummary />
        <UsageMeters loading={loading} state={state} />
        <SpendCapCard />
        <AddonsCard />
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <h3 className="text-lg font-semibold text-content">Plans</h3>
            <p className="max-w-2xl text-sm text-content2">
              Pay for what you store and the AI actions you run. Every plan includes storage, Smart Searches
              and managed embeddings; paid plans continue past the allowance at the listed rates.
            </p>
          </div>
          <SelectPeriod />
        </div>
        <Plans intendedPlan={intendedPlan} />
        <PricingComparison className="mt-8" />
      </PageContent>
    </WorkspacesLayout>
  )
}
